import Request from "../lib/request";
import { PROJECT_ID, PROJECT_USER_ID } from "../constants/storageKeys";
import {
  FILES_API,
  PROJECT_USERS_API,
  PROJECTS_API,
  REPORTS_API
} from "../constants/api";

const baseUrl = process.env.REACT_APP_API_URL;
const baseUrlAdmin = process.env.REACT_APP_API_ADMIN_URL;

export const askFile = data => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  const projectId = localStorage.getItem(PROJECT_ID);
  const base_url = data.isAdmin ? baseUrlAdmin : baseUrl;
  const first_url = data.projectBase
    ? `${PROJECTS_API}/${projectId}`
    : `${PROJECT_USERS_API}/${projectUserId}`;
  const end_url = data.isNotReport
    ? `${data.route}`
    : `${REPORTS_API}/${data.route}`;
  return Request({
    method: data.method,
    url: `${base_url}/${first_url}/${end_url}`,
    needToken: true,
    data: data.method === "post" ? data.filters : {},
    params: data.method === "get" ? data.filters : {}
  });
};
export const checkFiles = () => {
  return Request({
    method: "get",
    url: `${baseUrl}/${FILES_API}`,
    needToken: true
  });
};
